<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fa fa-clipboard"></i>
        Notice
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">게시판</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Notice</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              [{{model.type && model.type.value ? model.type.value.toUpperCase() : model.type.toUpperCase() }}]{{model.title}}
            </div>
            <div class="mb7">
              <span class="float-right">{{model.created_at | sdate}}</span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="Category">
                분류
              </label>
            </b-col>
            <b-col class="col-xl-10 col-md-12  d-flex align-self-center">
              <v-select class="w-100" label="text" :disabled="lock" v-model="model.type" :options="codes.BOARD_TYPE_DICT"></v-select>
              <!-- <select v-model="model.type" class="w-100" :disabled="lock">
                <option disabled value="">Please select solution</option>
                <option value="wfdetect">WFDetector : Detect and respond to forgery of web pagess</option>
                <option value="wmds">WMDS : Web Malware Detection System</option>
                <option value="wsfinder">WSFinder : WeShell Finder</option>
                <option value="webcastle">WEBCastle : Web Firewall</option>
              </select> -->
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_title">
                제목
              </label>
            </b-col>
            <b-col class="col-xl-10 col-md-12">
              <b-form-input class="form-control" md=5 type="text" id="ph_title" :disabled="lock" v-model="model.title"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="d-flex flex-wrap align-items-center">
            <b-col class="title_sub">
              <h4 for="ph_question">내용</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-xl-12 col-md-12">
              <vue-editor v-model="model.content" :disabled="lock" id="ph_question"></vue-editor>
            </b-col>
          </b-row>
          <hr v-if="!lock && !model.created_at">
          <b-form-checkbox v-model="model.is_mail" v-if="!lock && !model.created_at" style="display:inline-block; margin-left : 10px;">
            모든 사용자에게 메일 보내기
          </b-form-checkbox>
          <b-form-checkbox v-model="model.is_mail_partner" v-if="!lock && !model.created_at" style="display:inline-block; margin-left : 10px;">
            이메일시 파트너를 참조하기
          </b-form-checkbox>
          <br>
          <b-button size="sm" v-if="!lock" class="btn btn-add" @click="save"> 저장 </b-button>
          <b-button size="sm" v-else variant="warning" :disabled="model.is_del" @click="edit"> 편집 </b-button>
          <b-button size="sm" v-if="!lock && !add" variant="default" @click="cancel"> 취소 </b-button>
          <b-button size="sm" v-if="lock && model.id" variant="danger" :disabled="model.is_del" @click="confirm = true"> 삭제 </b-button>
          <b-button size="sm" class="float-right text-white" variant="primary" @click="list"> 목록 </b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-modal title="내용 삭제하기"  class="modal-danger" v-model="confirm" @ok="remove(model)" ok-variant="danger">
      데이터를 삭제하시겠습니까?
    </b-modal>
    <!-- {{model}} -->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>